<div class="mwp-modal-delete">
    <div class="header">
        <mwp-text-translate text="ACCOUNT DELETION NOTICE" jsonKey="deleteAccount1" />
    </div>
    <div class="body">
        <div class="message-container red mb-3">
            <div class="mb-2">
                <mwp-text-translate text="YOU ARE REQUESTING AN ACCOUNT DELETION. PLEASE NOTE THAT DELETING YOUR ACCOUNT WILL DO THE FOLLOWING:" jsonKey="deleteAccount2" />
            </div>
            <div class="mb-2">
                <mwp-text-translate text="- REMOVE USER ACCESS TO THE APP" jsonKey="deleteAccount3" />
            </div>
            <div class="mb-2">
                <mwp-text-translate text="- INABLITY TO RECOVER YOUR ACCOUNT" jsonKey="deleteAccount4" />
            </div>
            <div class="mb-2">
                <mwp-text-translate text="IF AT ANY POINT YOU WOULD LIKE TO REGAIN ACCESS, SIMPLY RE-REGISTER, OR ASK YOUR ADMINISTRATOR TO RECOVER YOUR ACCOUNT." jsonKey="deleteAccount5" />
            </div>
        </div>

        <div class="message-container blue-box">
            <mat-checkbox [(ngModel)]="isChecked" [checked]="isChecked" />
            <span class="checkbox-text">
                <mwp-text-translate text="I understand that deleting my account will remove my ability to access the site, and that I will have to re-register or speak with my administrator to regain access. I authorize the account deletion to proceed." jsonKey="deleteAccount6" />
            </span>
        </div>
    </div>
    <div class="footer d-inline-flex justify-content-end w-100">
        <button class="mwp-button-secondary me-3" (click)="close()">
            <mwp-text-translate text="CANCEL" jsonKey="cancel" />
        </button>
        <button class="mwp-button-delete" [disabled]="!isChecked" (click)="buttonClicked()">
            <mwp-text-translate text="DELETE ACCOUNT" jsonKey="deleteAccount7" />
        </button>
    </div>
</div>